/**
 * Интеграторы иногда передают return_url с двойным encodeURIComponent.
 * Тогда после одного декодирования в URLSearchParams строка остаётся вида
 * "https%3A%2F%2F...". Браузер не считает это абсолютным URL и склеивает
 * с текущим origin (получается passport.api-ssmm.ru/https%3A%2F%2F...).
 */
export function normalizeReturnUrl(raw: string | null | undefined): string | null {
  if (raw == null || typeof raw !== 'string') return null;
  let s = raw.trim();
  if (!s) return null;

  for (let i = 0; i < 5; i++) {
    if (/^https?:\/\//i.test(s)) {
      return s;
    }
    try {
      const decoded = decodeURIComponent(s);
      if (decoded === s) break;
      s = decoded;
    } catch {
      break;
    }
  }

  return s;
}
